export const useStartup = () => {
  const startedUp = window.localStorage.getItem("jwt");
  return startedUp ? true : false;
};
